export class DriverAccessError extends Error {
    constructor() {
        super('Driver access denied')
        this.name = 'DriverAccessError'
    }
}
